<template>
      <!--====== PART START ======-->

    <header class="appie-header-area appie-header-8-area appie-sticky ">
        <div class="container">
            <div class="header-nav-box header-nav-box-6">
                <div class="row align-items-center justify-content-between">
                    <div class="col-lg-3 col-md-3 col-sm-4 col-4 order-1 order-sm-1">
                        <div class="appie-logo-box">
                            <a href="/">
                                <img src="@/assets/images/logo.png" alt="">
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-1 col-sm-1 order-3 order-sm-2">
                        <div class="appie-header-main-menu">
                            <span class="ml-10">(+380) 66 408-59-58</span>
                        </div>
                    </div>
                    <div class="col-lg-6  col-md-8 col-sm-5 col-6 order-2 order-sm-3 d-flex align-items-center justify-content-end">
                        <div class="appie-header-main-menu mr-60">
                          <localizations :localizations="menuItems" :nasted="nasted" selected="RU"/>
                        </div>
                        <div class="appie-btn-box d-flex justify-content-end" style="text-align:right">
                          <div class="team-btn" >
                            <a  href="#"> Демо-доступ</a>
                          </div>
                            <b-button v-b-modal.auth_modal class="main-btn ml-15">Войти в кабинет</b-button>
                            <div class="toggle-btn ml-30 canvas_open d-lg-none d-block">
                                <i class="fa fa-bars" @click="showSidebar"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!--====== PART ENDS ======-->
</template>

<script>
import Localizations from '../Localizations.vue'
export default {
     props:{
      menuItems:{
          type: Array,
          required: true,
      },
      nasted:{
            type:Boolean,
            default:true
        }
    },
	components: { Localizations },
      mounted() {
        document.addEventListener('scroll', this.stickMenu)
    },
    methods:{
        showSidebar(e){
            this.$emit("toggleSidebar",e)
        },
        stickMenu(){
        const result = document.querySelector('.appie-sticky')
           if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                result.classList.add('sticky')
            } else {
                result.classList.remove('sticky')
            }
        }
    }

}
</script>

<style scoped>
@media (max-width: 542px) {
.main-btn{
    font-size: 15px;
    margin: 0;
    line-height: 40px;
    padding: 0 22px;
}
}

</style>